<template>
  <table class="dividends-table">
    <thead>
      <tr>
        <th>{{ $t('trade.holdings-detail-page.table-date') }}</th>
        <th>{{ $t('trade.holdings-detail-page.table-currency') }}</th>
        <th>{{ $t('trade.holdings-detail-page.table-div-amount') }}</th>
      </tr>
    </thead>
    <tbody v-if="dividends.length > 0">
      <tr v-for="dvd in dividends" :key="dvd.id">
        <td>{{ dvd.date | formatDate }}</td>
        <td>{{ dvd.currency }}</td>
        <td>{{ dvd.amount }}</td>
      </tr>
    </tbody>
    <NoData v-else-if="!loading" :text="$t('quote.no-data')" />
  </table>
</template>
<script>
import NoData from 'com/NoData'
export default {
  name: 'DividendTable',
  components: { NoData },
  props: {
    dividends: Array,
    loading: Boolean
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';

.dividends-table {
  width: 100%;
  flex: 1;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  tr {
    display: flex;
    justify-content: space-between;
  }
  th,
  td {
    overflow: hidden;
    &:nth-child(1) {
      flex: 6;
      text-align: left;
    }
    &:nth-child(2) {
      flex: 3;
      text-align: center;
    }
    &:nth-child(3) {
      flex: 4;
      text-align: right;
    }
  }
  tbody {
    flex: 1;
    overflow-y: auto;
    tr {
      &:nth-child(2n + 1) {
        background-color: var(--divide-color);
      }
    }
  }
}
.no-data {
  padding: 20px 0;
  text-align: center;
}
</style>
